<template>
  <div>
    <v-menu
      v-model="isHelpMenuOpen"
      location="right"
      :offset="[10, 0]"
      content-class="mini-user-info user-support"
    >
      <template v-slot:activator="{ props }">
        <v-badge
          class="left-menu__badge"
          :model-value="isNewVideoOnPlaylist"
          :offset-x="5"
          :offset-y="26"
          color="#E85A63"
          dot
        >
          <LeftMenuItem
            class="left-menu__item--help"
            :item="item"
            :mini="mini"
            :active="isActive"
            v-bind="props"
            @click="handleSelect"
          />
        </v-badge>
      </template>
      <div>
        <div class="mini-user-info__buttons">
          <v-btn
            target="_blank"
            :href="supportUrl"
            variant="text"
            class="user-support-text mini-user-info__tg-btn"
            @click="isHelpMenuOpen = false"
          >
            <v-icon color="secondary" size="18" class="mr-2" icon="tgSupport" />
            Поддержка в TG
          </v-btn>
          <div class="d-flex align-center user-support-text">
            <v-btn variant="text" class="user-support-text" @click="openPlaylist">
              <v-icon color="secondary" size="18" class="mr-2" icon="play" />
              Видеоуроки
            </v-btn>
            <div v-if="isNewVideoOnPlaylist" class="user-support__new">NEW</div>
          </div>
        </div>
      </div>
    </v-menu>
    <PopupVue v-model="isOpenPopupPlaylist" :width="'55%'">
      <iframe
        v-if="isOpenPopupPlaylist"
        width="850"
        height="600"
        style="border-radius: 8px"
        :src="playlistSrc"
        :title="playlistTitle"
        frameborder="0"
        allow="
          accelerometer;
          autoplay;
          clipboard-write;
          encrypted-media;
          gyroscope;
          picture-in-picture;
          web-share;
        "
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </PopupVue>
  </div>
</template>

<script>
import LeftMenuItem from "@/components/Navigation/LeftMenuItem.vue";
import PopupVue from "@/components/Utils/PopupVue.vue";

export default {
  name: "left-menu-help",
  components: { PopupVue, LeftMenuItem },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    supportUrl: {
      type: String,
      default: "https://t.me/zarbotech_support",
    },
    playlistSrc: {
      type: String,
      default: "https://rutube.ru/play/embed/e0a64af6eec127d13813d4e58407b7ef?playlist_id=607838",
    },
    playlistTitle: {
      type: String,
      default: "RUTUBE video player",
    },
  },
  data: () => ({
    isHelpMenuOpen: false,
    isOpenPopupPlaylist: false,
    isNewVideoOnPlaylist: false,
  }),
  computed: {
    isActive() {
      return this.active;
    },
  },
  created() {
    this.initializePlaylistBadge();
  },
  methods: {
    initializePlaylistBadge() {
      const lastOpen = localStorage.getItem("lastOpenPlaylist");
      const legacyLastOpen = localStorage.getItem("lastOpenYoutubePlaylist");

      if (lastOpen) {
        this.isNewVideoOnPlaylist = false;
        return;
      }

      if (legacyLastOpen) {
        localStorage.setItem("lastOpenPlaylist", legacyLastOpen);
        this.isNewVideoOnPlaylist = false;
        return;
      }

      this.isNewVideoOnPlaylist = true;
    },
    handleSelect() {
      this.$emit("select");
    },
    openPlaylist() {
      this.isOpenPopupPlaylist = true;
      this.isHelpMenuOpen = false;
      this.isNewVideoOnPlaylist = false;
      localStorage.setItem("lastOpenPlaylist", new Date().toISOString());
    },
  },
};
</script>
